import { render, staticRenderFns } from "./ElementIcon.vue?vue&type=template&id=5a3749b4&"
import script from "./ElementIcon.vue?vue&type=script&lang=js&"
export * from "./ElementIcon.vue?vue&type=script&lang=js&"
import style0 from "./ElementIcon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ElementIcon.vue"
export default component.exports